var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoTaggingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49.5938,
    r: 49,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.0013,
    cy: 49.5941,
    r: 40.8333,
    fill: "#00BBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6083 33.3008H31.8633V41.4516H40.6083V33.3008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5353 33.3008H43.6641V35.9767H46.5353V33.3008Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0828 33.3008H49.6016V49.5939H67.0828V33.3008Z",
    fill: "#4B4C4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0828 48.567V49.5939H49.6016V33.3008H50.6517V48.567H67.0828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6083 45.5762H31.8633V53.727H40.6083V45.5762Z",
    fill: "#4B4C4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6993 53.0947H43.8281V55.7706H46.6993V53.0947Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9742 53.4102H61.4414V55.7712H63.9742V53.4102Z",
    fill: "#4B4C4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5524 53.4102H53.0195V55.7712H55.5524V53.4102Z",
    fill: "#4B4C4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1969 42.7783H43.6641V45.1394H46.1969V42.7783Z",
    fill: "#4B4C4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6083 58.2158H31.8633V66.3667H40.6083V58.2158Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8427 58.2158H45.0977V66.3667H53.8427V58.2158Z",
    fill: "#4B4C4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.081 58.2158H58.3359V66.3667H67.081V58.2158Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2617 33.3008V38.6729L65.1533 39.3914V33.3008H60.2617Z",
    fill: "#42A2DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTaggingIcon);
export default __webpack_public_path__ + "static/media/AutoTaggingIcon.2ca93586357c4a2843a939944824e4d0.svg";
export { ForwardRef as ReactComponent };